module.exports = __webpack_public_path__ + "5fdf60fda912437bbce2bec923d5e862.svg";